import DOMPurify from "dompurify";
const RICH_TEXT_ALLOWED_TAGS = [
    "p",
    "br",
    "strong",
    "b",
    "em",
    "i",
    "u",
    "s",
    "ul",
    "ol",
    "li",
    "a",
    "span",
];
const RICH_TEXT_ALLOWED_ATTR = ["href", "target", "rel"];
export function sanitizeRichHtml(input) {
    if (!input)
        return "";
    return DOMPurify.sanitize(input, {
        ALLOWED_TAGS: RICH_TEXT_ALLOWED_TAGS,
        ALLOWED_ATTR: RICH_TEXT_ALLOWED_ATTR,
    });
}
export function hasVisibleText(input) {
    return htmlToPlainLines(input).length > 0;
}
export function htmlToPlainLines(input) {
    return (input ?? "")
        .replace(/<\/(p|div|h[1-6]|li|ul|ol)>/gi, "\n")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<li[^>]*>/gi, "\n")
        .replace(/<[^>]+>/g, " ")
        .replace(/&nbsp;/gi, " ")
        .replace(/&amp;/gi, "&")
        .replace(/&lt;/gi, "<")
        .replace(/&gt;/gi, ">")
        .replace(/&quot;/gi, '"')
        .replace(/&#0?39;|&apos;/gi, "'")
        .split(/\n+/)
        .map((line) => line.replace(/\s+/g, " ").trim())
        .filter(Boolean);
}
